// The AI Training page is one account's alone (Ryan, 2026-10-24: "lock it to that"). The portal refuses every other
// account as well, another admin included (backend app/training_autopilot.py TRAINING_OWNER); this only keeps the
// link and the page out of their sight. Changing the owner is a code change on both sides.
export const TRAINING_OWNER = 'hello@uncutgems.com';

export const isTrainingOwner = (user) =>
  user?.role === 'admin' && String(user?.email || '').trim().toLowerCase() === TRAINING_OWNER;
